import { Grid } from '@mui/material'
import React from 'react'
import { customStyles } from '../../../styles'
import { MainContainer } from '../../containers'
import { RegularText, SubTitle } from '../../helpers'
import { ModalHeader } from '../../modals'
import { EvidenceOrder } from './EvidenceOrder'
import { HelpThisOrder } from './HelpThisOrder'
import { InfoDelivery } from './InfoDelivery'
import { InforOrder } from './InfoOrder'
import { ListImagesEvidence } from './ListImagesEvidence'
import { OrderComments } from './OrderComments'

export const OrderDone = () => {
  const { colors: { main } } = customStyles
  return (
    <MainContainer>
      <ModalHeader backward/>
      <SubTitle text="Pedido de gas" color={ main }/>
      <RegularText text="Información del pedido"/>
      <InforOrder />
      <RegularText text="Información del repartidor" sx={{ marginTop: 3 }}/>
      <InfoDelivery />
      <OrderComments />
      <RegularText text="¿Necesitas ayuda con este pedido?" sx={{ marginTop: 3 }}/>
      <HelpThisOrder />
      <RegularText text="Evidencias del pedido" sx={{ marginTop: 3 }}/>
      <ListImagesEvidence />
      
      {/*ADD TOGGLE BUTTON */}
      {/* <EvidenceOrder /> */}
    </MainContainer>
  )
}
